/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react'
import { DSNumberInfoIcon } from 'shared-definitions/types'
import Edit from 'shared-svg/Edit.svg'
import Youtube from 'shared-svg/Youtube.svg'
import Instagram from 'shared-svg/Instagram.svg'
import Computer from 'shared-svg/Computer.svg'
import Calendar from 'shared-svg/Calendar.svg'
import Headphone from 'shared-svg/Headphone.svg'

const componentsMap: Record<DSNumberInfoIcon, React.VFC> = {
  file_edit: Edit,
  calendar: Calendar,
  headphone: Headphone,
  computer: Computer,
  youtube: Youtube,
  instagram: Instagram,
}

interface NumberInfoIconProps extends React.SVGAttributes<SVGElement> {
  icon: DSNumberInfoIcon
}

const NumberInfoIcon: React.VFC<NumberInfoIconProps> = ({ icon, ...props }) => {
  const Component = componentsMap[icon]
  if (Component) {
    return <Component {...props} />
  }
  return <Edit {...props} />
}

export default NumberInfoIcon
